export default function CertificateCard({
  title,
  provider,
  link,
  date,
  image,
}) {
  return (
    <div className="hover-glow group bg-white/[0.03] border border-white/5 rounded-lg p-6 flex flex-col items-center text-center w-full max-w-xs">
      <div className="relative mb-5">
        <span className="absolute inset-0 rounded-full ring-1 ring-[#D4AF6A]/40 scale-110" />
        <img
          className="w-16 h-16 object-cover rounded-full"
           src={process.env.REACT_APP_MEDIA_URL + image}
          alt={title}
        />
      </div>

      <h3 className="text-[#F1E9D8] font-display text-lg mb-1">{title}</h3>
      <p className="text-sm text-[#93A894] mb-4">
        {provider} · {new Date(date).getFullYear()}
      </p>

      {link && !link.includes("empty") && (
        <a
          href={process.env.REACT_APP_MEDIA_URL + link}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-auto text-sm text-[#D4AF6A] inline-flex items-center gap-1.5 group-hover:gap-2.5 transition-all duration-300"
        >
          View Certificate
          <svg className="w-3 h-3" viewBox="0 0 16 16" fill="none">
            <path
              d="M1 8h13M8 1l6 7-6 7"
              stroke="#D4AF6A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      )}
    </div>
  );
}
